export default __webpack_public_path__ + "static/media/conversion.17b42862.png";